module.exports = __webpack_public_path__ + "static/media/schedule_hours.3dd7dc8b.svg";